import React from 'react';

/**
 * Represents the data context for the application.
 */
const DataContext = React.createContext();

export default DataContext;